export default "__VITE_ASSET__BitMWB3W__"